/**
 * 날짜 입력(.datepicker / .datepicker::placeholder) 스타일 — 파일별 실측값(높이·radius·hover색·
 * font-family 위치)을 인자로 그대로 전달해 렌더 결과 보존. color/margin-bottom/MuiSvgIcon-root 등
 * 필드가 추가로 있는 변형(PageInput, setting/Admin·Preference, monitoring/DeviceDetail)은 대상 아님.
 */
export const datepickerInputStyles = (
  theme: any,
  {
    height = '53.13px',
    borderRadius = '10px',
    hoverColor,
    fontFamilyFirst = false,
    padding,
  }: {
    height?: string;
    borderRadius?: string;
    hoverColor?: string;
    fontFamilyFirst?: boolean;
    padding?: string;
  } = {},
) => `
  .datepicker {
    ${fontFamilyFirst ? 'font-family: MainFont;' : ''}
    width: 100%;
    height: ${height};
    ${padding ? `padding: ${padding};` : ''}
    border: 1px solid ${theme.palette.mode === 'dark' ? '#56596A' : '#C7C7C7'};
    border-radius: ${borderRadius};
    outline: none;
    background: ${theme.palette.background.paper};
    ${!fontFamilyFirst ? 'font-family: MainFont;' : ''}
    &:hover {
      border: 1px solid ${hoverColor || theme.colors.alpha.black[50]};
    }
  }
  .datepicker::placeholder {
    color: ${theme.palette.mode === 'dark' ? '#8F919C' : '#626B80'};
  }
`;

/**
 * DatePickerBox — .datepicker(40px·color·margin-bottom 포함) + .react-datepicker* 전체 세트.
 * setting/Admin ↔ setting/Preference 바이트 동일.
 */
export const datePickerBoxStyles = (theme: any) => `
  .datepicker {
    margin-bottom: 16px;
    font-family: MainFont;
    color: ${theme.header.textColor};
    width: 100%;
    height: 40px;
    border: 1px solid ${theme.palette.mode === 'dark' ? '#56596A' : '#C7C7C7'};
    border-radius: 10px;
    outline: none;
    background: ${theme.palette.background.paper};
    &:hover {
      border: 1px solid ${theme.colors.alpha.black[50]};
    }
    &:disabled {
      color: rgba(34, 51, 84, 0.5);
    }
  }
  .datepicker::placeholder {
    color: ${theme.palette.mode === 'dark' ? '#8F919C' : '#626B80'};
  }
  .react-datepicker__input-container input {
    text-align: center;
     padding-right: 2.5rem;
  }
  .react-datepicker-popper {
    margin-top: 0px;
  }
  .react-datepicker-wrapper {
    width: 100%;
    .react-datepicker__close-icon {
      margin-right: 8px;
    }
    .react-datepicker__close-icon::after {
      background-color: ${theme.palette.primary.main};
    }
  }
  .datepicker_icon {
    margin-right: 18px;
    right: 0;
    @media (max-width: 899px) {
      margin-top: 2px;
      margin-right: 12px;
      .MuiSvgIcon-root {
        width: 20px;
        height: 20px;
      }
    }
  }
`;
